<template>
  <nav class="navbar" :class="{ scrolled }">
    <a href="#" class="nav-logo" @click.prevent="handleHome">
      <img src="/img/logo.8db55515.png" alt="Kordelo logo" style="height:34px;width:auto;" />
      Kordelo
    </a>

    <ul class="nav-links" :class="{ 'mobile-open': mobileOpen }">
      <li><a href="#" @click.prevent="handleHome">{{ $t('nav.home') }}</a></li>
      <li><a href="/features" @click.prevent="handleNav('/features')">{{ $t('nav.features') }}</a></li>
      <li><a href="/how" @click.prevent="handleNav('/how')">{{ $t('nav.howItWorks') }}</a></li>
      <li><a href="/contact" @click.prevent="handleNav('/contact')">{{ $t('nav.contact') }}</a></li>
      <li class="nav-lang-mobile">
        <div class="lang-switcher">
          <a href="#" class="lang-option" :class="{ active: $i18n.locale === 'en' }" @click.prevent="switchLang('en')">🇬🇧</a>
          <a href="#" class="lang-option" :class="{ active: $i18n.locale === 'no' }" @click.prevent="switchLang('no')">🇳🇴</a>
        </div>
      </li>
    </ul>

    <div class="nav-actions">
      <div class="lang-switcher">
        <a
          href="#"
          class="lang-option"
          :class="{ active: $i18n.locale === 'en' }"
          @click.prevent="switchLang('en')"
        >🇬🇧</a>
        <a
          href="#"
          class="lang-option"
          :class="{ active: $i18n.locale === 'no' }"
          @click.prevent="switchLang('no')"
        >🇳🇴</a>
      </div>
      <RouterLink
        class="btn-primary"
        to="/signin"
      >
        {{ $t('nav.openApp') }}
        <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </RouterLink>
    </div>

    <button class="nav-hamburger" aria-label="Menu" @click="mobileOpen = !mobileOpen">
      <span></span><span></span><span></span>
    </button>
  </nav>
</template>

<script>
  export default {
    name: 'NavBar',
    data: () => ({
      scrolled: false,
      mobileOpen: false,
    }),
    mounted() {
      window.addEventListener('scroll', this.onScroll, { passive: true })
      this.onScroll()
    },
    unmounted() {
      window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
      switchLang(l) {
        this.$i18n.locale = l
        localStorage.setItem('locale', l)
      },
      onScroll() {
        this.scrolled = window.scrollY > 10
      },
      handleHome() {
        this.mobileOpen = false
        if (this.$route.path === '/') {
          window.scrollTo({ top: 0, behavior: 'smooth' })
        } else {
          this.$router.push('/')
        }
      },
      handleNav(path) {
        this.mobileOpen = false
        this.$router.push(path)
      },
    }
  }
</script>

<style scoped>
.navbar {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  padding: 0 2rem;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(245, 242, 238, 0.88);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(226, 232, 240, 0.6);
  transition: box-shadow var(--transition);
}

.navbar.scrolled { box-shadow: var(--shadow-md); }

.nav-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--text);
  letter-spacing: -0.02em;
}

.nav-logo-icon {
  width: 36px; height: 36px;
  background: linear-gradient(135deg, var(--primary) 0%, var(--secondary) 100%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-logo-icon svg { width: 20px; height: 20px; fill: none; stroke: white; stroke-width: 2; }

.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
  list-style: none;
}

.nav-links a {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-muted);
  transition: color var(--transition);
}

.nav-links a:hover { color: var(--text); }

.nav-actions { display: flex; align-items: center; gap: 1rem; }

.btn-ghost {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-muted);
  padding: 0.5rem 1rem;
  border-radius: var(--radius-sm);
  transition: background var(--transition), color var(--transition);
  border: none;
  background: none;
  cursor: pointer;
}

.btn-ghost:hover { background: var(--border); color: var(--text); }

/* ─── Language switcher ────────────────────────────────────────────── */
.lang-switcher {
  display: flex;
  align-items: center;
  background: var(--border);
  border-radius: 100px;
  padding: 3px;
  gap: 1px;
}

.lang-option {
  padding: 3px 8px;
  border-radius: 100px;
  font-size: 1.05rem;
  line-height: 1.4;
  color: var(--text-muted);
  transition: all var(--transition);
}

.lang-option:hover { color: var(--text); }

.lang-option.active {
  background: white;
  color: var(--text);
  box-shadow: var(--shadow-sm);
}

/* Hamburger */
.nav-hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  padding: 4px;
  background: none;
  border: none;
}

.nav-hamburger span {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--text);
  border-radius: 2px;
  transition: all 0.3s;
}

.nav-links.mobile-open {
  display: flex !important;
  position: fixed;
  top: 68px;
  left: 0;
  right: 0;
  flex-direction: column;
  background: rgba(245, 242, 238, 0.97);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  padding: 1.5rem 2rem;
  gap: 1.25rem;
  border-bottom: 1px solid var(--border);
  z-index: 99;
}

@media (max-width: 900px) {
  .nav-links { display: none; }
  .nav-hamburger { display: flex; }
  .nav-actions .lang-switcher { display: none; }
}

.nav-lang-mobile { display: none; }

@media (max-width: 900px) {
  .nav-lang-mobile { display: flex; }
}

@media (max-width: 700px) {
  .navbar { padding: 0 1.25rem; }
}
</style>
